<template>
    <div>
        <div style="font-weight: bold;margin-bottom: 20px;">出纳金开关配置</div>
        <el-radio-group v-model="cryptoSwitch" style="margin-right: 20px;">
            <el-radio label="true" border>打开</el-radio>
            <el-radio label="false" border>关闭</el-radio>
        </el-radio-group>
        <div style="font-weight: bold;margin-bottom: 20px;margin-top: 20px;">出纳金灰度开关配置</div>
        <el-radio-group v-model="gray" style="margin-right: 20px;">
            <el-radio label="true" border>打开</el-radio>
            <el-radio label="false" border>关闭</el-radio>
        </el-radio-group>
        <div style="margin-top: 20px;">白名单配置conf_key: SITE_NEW_FEATURE_USER_LIST_crypto_trade</div>
        <div style="font-weight: bold;margin-bottom: 20px;margin-top: 20px;width: 160px">
            <el-button type="primary" @click="saveCryptoSwitch()" style="width: 100%">保存</el-button>
        </div>
    </div>
</template>

<script>
    import api from './api';
    export default {
        name: "pettyCash",
        data(){
          return {
              cryptoSwitch:'false',
              gray: 'true',
          }
        },
        methods:{
            saveCryptoSwitch(){
                api.alterCryptoSwitch({status:this.cryptoSwitch,gray:this.gray});
            }
        },
        created() {
            api.queryCryptoSwitch().then(response =>{
                this.cryptoSwitch = response.data.cryptoSwitch + '';
                this.gray = response.data.gray + '';
            });
        }
    }
</script>

<style scoped>

</style>